import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes';
import { SidebarProvider } from "./contexts/SidebarContext";
import katex from "katex";
import "katex/dist/katex.min.css";

window.katex = katex;
const App = () => (
  <AuthProvider>
     <SidebarProvider>
        <AppRoutes />
     </SidebarProvider>
  </AuthProvider>
);

export default App;